{{ userPublicNameTruncated() }}
